import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { SEOHead } from '@/components/SEOHead';

export const MentionsLegalesPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead 
        title="Mentions légales | Homely Solutions"
        description="Mentions légales de Homely Solutions Sàrl, entreprise de services immobiliers en Suisse romande."
      />
      
      <Header />
      
      <main className="py-20">
        <div className="mx-auto w-full max-w-[var(--container)] px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-8" style={{ fontFamily: 'var(--font-heading)' }}>
            Mentions légales
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <section className="mb-12">
              <h2 className="text-2xl font-semibold mb-4">1. Éditeur du site</h2>
              <p>Le site www.homely-solutions.ch et la marque Homely Solutions sont la propriété exclusive de :</p>
              <div className="bg-gray-50 p-6 rounded-lg mt-4">
                <p><strong>Homely Solutions Sàrl</strong></p>
                <p>Rue Jean-André Venel 4</p>
                <p>1400 Yverdon-les-Bains</p>
                <p>Suisse</p>
                <p className="mt-4"><strong>Forme juridique :</strong> Société à responsabilité limitée (Sàrl)</p>
                <p><strong>Email :</strong> <a href="mailto:contact@homely-solutions.ch" className="text-[var(--sage)] hover:underline">contact@homely-solutions.ch</a></p>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold mb-4">2. Directeur de la publication</h2>
              <p>Le directeur de la publication du site www.homely-solutions.ch est le représentant légal de Homely Solutions Sàrl.</p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold mb-4">3. Hébergement</h2>
              <p>Ce site est hébergé en Suisse conformément aux exigences de protection des données suisses et européennes (RGPD).</p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold mb-4">4. Propriété intellectuelle</h2>
              <p>
                L'ensemble des éléments constituant le site www.homely-solutions.ch (textes, graphismes, logiciels, 
                photographies, images, vidéos, sons, plans, logos, marques, créations et œuvres protégeables diverses, 
                bases de données, etc.) ainsi que le site lui-même, relèvent des législations suisses et internationales 
                sur le droit d'auteur et la propriété intellectuelle.
              </p>
              <p>
                La marque "Homely Solutions" et son logo sont des marques déposées appartenant à Homely Solutions Sàrl.
                Toute reproduction, représentation, utilisation ou adaptation, sous quelque forme que ce soit, 
                de tout ou partie de ces éléments, sans l'accord préalable et écrit de Homely Solutions Sàrl, 
                est strictement interdite.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold mb-4">5. Limitation de responsabilité</h2>
              <p>
                Homely Solutions Sàrl s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur 
                ce site, dont elle se réserve le droit de corriger le contenu à tout moment et sans préavis.
              </p>
              <p>
                Toutefois, Homely Solutions Sàrl ne peut garantir l'exactitude, la précision ou l'exhaustivité des 
                informations mises à disposition sur ce site. En conséquence, Homely Solutions Sàrl décline toute 
                responsabilité pour les éventuelles imprécisions, inexactitudes ou omissions portant sur des 
                informations disponibles sur ce site.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold mb-4">6. Liens hypertextes</h2>
              <p>
                Le site www.homely-solutions.ch peut contenir des liens hypertextes vers d'autres sites internet. 
                Homely Solutions Sàrl n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à 
                leur contenu ou aux éventuels dommages liés à leur utilisation.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold mb-4">7. Droit applicable et juridiction</h2>
              <p>
                Les présentes mentions légales sont régies par le droit suisse. En cas de litige, et après tentative 
                de résolution amiable, les tribunaux du canton de Vaud seront seuls compétents.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">8. Contact</h2>
              <p>
                Pour toute question concernant ces mentions légales ou le site, vous pouvez nous contacter à l'adresse 
                suivante : <a href="mailto:contact@homely-solutions.ch" className="text-[var(--sage)] hover:underline">contact@homely-solutions.ch</a>
              </p>
            </section>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};
